import React from 'react'

import Sidebar from 'shared/components/ui/Sidebar'

import ValidatedField from 'shared/components/ui/ValidatedField'
import { Label } from 'shared/ui'
import { Form, Input, Button } from 'util/ui'
import styles from '../styles.less'

export default class CreateContact extends React.PureComponent {
  handleChange = (_, { name, value }) => {
    return this.props.onChange(name, value, null, { validate: true })
  }

  render() {
    const {
      onClose,
      doCreateLead,
      createContactError,
      open,
      formFields,
      formFieldsErrors,
      isFormValid,
    } = this.props
    const errorMessages = createContactError && createContactError.join('\n')
    return (
      <Sidebar
        headerChildren="Create Lead"
        footerChildren={
          <React.Fragment>
            <Button
              disabled={!isFormValid}
              fluid
              onClick={doCreateLead}
              primary
            >
              Save changes
            </Button>
            <Button fluid onClick={onClose} basic>
              Cancel
            </Button>
          </React.Fragment>
        }
        narrow
        onClose={onClose}
        open={open}
      >
        <Form className={styles.content}>
          <React.Fragment>
            <div className={styles.row} flex="1">
              <Label as="div">Email Address</Label>
              <ValidatedField
                disabled={false}
                fluid
                name="Email"
                onChange={this.handleChange}
                validatedFieldComponent={Input}
                errorMessage={errorMessages || formFieldsErrors.Email}
                value={formFields.Email || ''}
              />
            </div>

            <div className={styles.row} flex="1">
              <Label as="div">
                First Name <span className={styles.optional}>optional</span>
              </Label>
              <ValidatedField
                disabled={false}
                fluid
                name="FirstName"
                onChange={this.handleChange}
                validatedFieldComponent={Input}
                value={formFields.FirstName || ''}
              />
            </div>

            <div className={styles.row} flex="1">
              <Label as="div">
                Last Name <span className={styles.optional}>optional</span>
              </Label>
              <ValidatedField
                disabled={false}
                fluid
                name="LastName"
                onChange={this.handleChange}
                validatedFieldComponent={Input}
                value={formFields.LastName || ''}
              />
            </div>

            <div className={styles.row} flex="1">
              <Label as="div">
                Phone Number <span className={styles.optional}>optional</span>
              </Label>
              <ValidatedField
                disabled={false}
                fluid
                name="Phone"
                onChange={this.handleChange}
                validatedFieldComponent={Input}
                value={formFields.Phone || ''}
              />
            </div>

            <div className={styles.row} flex="1">
              <Label as="div">
                Company <span className={styles.optional}>optional</span>
              </Label>
              <ValidatedField
                disabled={false}
                fluid
                name="Company"
                onChange={this.handleChange}
                validatedFieldComponent={Input}
                value={formFields.Company || ''}
              />
            </div>

            <div className={styles.row} flex="1">
              <Label as="div">
                Website <span className={styles.optional}>optional</span>
              </Label>
              <ValidatedField
                disabled={false}
                fluid
                name="Website"
                onChange={this.handleChange}
                validatedFieldComponent={Input}
                value={formFields.Website || ''}
              />
            </div>
          </React.Fragment>
        </Form>
      </Sidebar>
    )
  }
}
